import router, { ViewType } from '@/router'
import { routerAddQueryParam } from '../../Router/Methods/routerAddQueryParam'

export function sidebarPushRightView(view: ViewType, leftReset?: boolean, rightReset?: boolean) {
  const url = routerAddQueryParam(window.history.state.current, {
    right: view && !rightReset ? ViewType[view] : null,
    m: null,
    ...(leftReset ? {left: ViewType.chats} : {}),
  })

  if (rightReset && leftReset) {
    router.push(routerAddQueryParam('/chats/0', {left: ViewType.chats, right: null, m: null}))
  } else if (window.history.state.back === url) {
    router.back()
  } else {
    router.push(url)
  }
}
